export function waitFor(predicate, timeout) {
  return new Promise(function (resolve, reject) {
    var _check = function check() {
      try {
        if (predicate()) {
          resolve();
        } else {
          setTimeout(_check, timeout);
        }
      } catch (error) {
        reject(error);
      }
    };
    _check();
  });
}
export function newDefered() {
  var resolve;
  var reject;
  var promise = new Promise(function (resolvePromise, rejectPromise) {
    resolve = resolvePromise;
    reject = rejectPromise;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
}